<h2> {{formPropertyCode}}</h2>
<div class="container-fluid glb-popup">
  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:10px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="onIndexChange($event)">
      <mat-tab label="Property">
        @if (propertyId) {
          <app-properties [propertyId]="propertyId"></app-properties>
        }
        <!-- <app-occupancy-summary></app-occupancy-summary> -->
      </mat-tab>
      <mat-tab label="Reservation">
        <app-reservations-list [titleFontSize]="true" [propertyId]="propertyId"></app-reservations-list>
        <!-- <app-rate-los></app-rate-los> -->
      </mat-tab>
      <mat-tab label="Setting">
        @if (propertyId) {
          <app-properties [showFields]="true" [propertyId]="propertyId"></app-properties>
        }
        <!-- <app-tape-chart-list></app-tape-chart-list> -->
      </mat-tab>
      <mat-tab label="Rate">
        <app-tape-chart-list [titleFontSize]="true" [propertyId]="propertyId" [startDate]="filteredCheckInDate" [endDate]="filteredCheckOutDate"></app-tape-chart-list>
        <!-- <app-rateBuckets-list></app-rateBuckets-list> -->
        <!-- <app-rate-bulk-edit></app-rate-bulk-edit> -->
      </mat-tab>
      <mat-tab label="Seasons">
        <app-rateSeason-list [titleFontSize]="true" [rateBucketId]="rateBucketId" [checkInDate]="filteredCheckInDate" [checkOutDate]="filteredCheckOutDate"></app-rateSeason-list>
        <!-- <app-rate-summary></app-rate-summary> -->
      </mat-tab>
      <mat-tab label="Quality Test">
        <app-quality-test-list [propertyId]="propertyId"></app-quality-test-list>
      </mat-tab>
      <!-- <mat-tab *ngIf="propertyId" label="History">
      <app-change-history-list [localId]="propertyId" [typeName]="'com.yieldmax.multi.property.PropertyVO'"></app-change-history-list>
    </mat-tab> -->
    @if (propertyId) {
      <mat-tab label="History">
        @if (propertyId) {
          <app-audit-list [source]="'YM'" [auditUrl]="'properties/' + propertyId + '/audit'"></app-audit-list>
        }
      </mat-tab>
    }
  </mat-tab-group>
</div>
